import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
// import './tailwind.generated.css';
// import './styles/main.scss';

import App from './app';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

ReactDOM.render(<App />, document.getElementById('root'));
